import React from 'react'
import MasProductModal from '../../../../components/common/form/modal/MasProductModal'

const MasProductModalContainer = ({ title, open, handleClose, selectedProduct }) => {
    return (
        <div>
            <MasProductModal
                title={title}
                open={open}
                handleClose={handleClose}
                selectedProduct={selectedProduct}
            />
        </div>
    )
}

export default MasProductModalContainer